<template>
	<div class="full-height">
		<Header @menuChange="changeMenu"></Header>
		<div class="flex-center">
			<div class="main-container" ref="main">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="#">参观预约</a>
						<span> > </span>
						<a href="/booking">网上预约</a>
					</span>
				</div>

				<div class="flex" style="min-height: 765px;justify-content: center;width: 100%;">
					<div class="text-overflow-hidden detail-container flex" style="width: 100%;">
						<div class="menu-container">
							<a v-for="item in menus.children" :href="getMenuLink(item)">
								<div :class="{'menu-item-icontainer-active' : (nowMenuId == item.id), 'menu-item-container':true, 'flex-center' : true}">
									{{item.nameZh}}
								</div>
							</a>
						</div>

						<div class="full-width" v-loading="loading">
							<h1 class="title">预约信息</h1>
							<el-form ref="form" class="text-left" :model="form" size="medium" label-width="120px">
								<el-form-item label="单位名称">
									<el-input v-model="form.institution" placeholder="请输入单位名称" clearable style="width: 840px;color: #333333;" />
								</el-form-item>

								<el-form-item label="参观时间">
									<el-date-picker v-model="form.comeTime" clearable type="datetime" placeholder="请选择参观时间">
									</el-date-picker>
								</el-form-item>

								<el-form-item label="参观人数">
									<el-input v-model="form.people" placeholder="请输入参观人数" clearable style="width: 840px;" />
								</el-form-item>

								<el-form-item label="团队类型">
									<el-select v-model="form.type" clearable placeholder="请选择团队类型">
										<el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>

								<el-form-item label="联系人">
									<el-input v-model="form.contact" placeholder="请输入联系人" clearable style="width: 840px;" />
								</el-form-item>

								<el-form-item label="联系电话">
									<el-input v-model="form.tel" clearable placeholder="请输入联系电话" style="width: 840px;" />
								</el-form-item>

								<el-form-item label="预约需求">
									<el-input v-model="form.remark" type="textarea" placeholder="您可以备注您的预约需求" :autosize="{minRows : 3}" clearable
									 style="width: 840px;" />
								</el-form-item>

								<el-form-item label="验证码">
									<el-input v-model="form.code" maxlength="4" placeholder="请输入验证码" clearable style="width: 180px;" />
									<img :src="code.base64" @click="getCode" class="code" />
								</el-form-item>
								<div class="flex-center">
									<div class="btn-submit hand-cursor" @click="submitForm">
										<span>提交</span>
									</div>
								</div>
							</el-form>
						</div>
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../components/Header';
	import Footer from '../../components/Footer';
	import api from '../../http/booking'
	import commonApi from '../../http/common'
	const defaultForm = {
		institution: null,
		comeTime: null,
		people: null,
		type: null,
		contact: null,
		tel: null,
		remark: null,
		codeKey: null,
		code: null
	};
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				nowMenuId: 3,
				menus: {},
				data: {},
				typeOptions: [
					//1：成人，2：中小学生，3：大学生，4：党员，5：部队
					{
						label: "成人",
						value: 1
					},
					{
						label: "中小学生",
						value: 2
					},
					{
						label: "大学生",
						value: 3
					},
					{
						label: "党员",
						value: 4
					},
					{
						label: "部队",
						value: 5
					},
				],
				form: {
					institution: null,
					comeTime: null,
					people: null,
					type: null,
					contact: null,
					tel: null,
					remark: null,
					codeKey: null,
					code: null
				},
				code: {},
				loading: false

			}
		},
		methods: {
			getCode() {
				const _this = this;
				commonApi.getCode().then(res => {
					_this.code = res;
					_this.form.codeKey = res.code;
				})
			},
			changeMenu(allMenus) {
				this.menus = allMenus.find(item => {
					if (item.id == 15) {
						return true;
					}
				});
				var menu = this.menus.children.find(item => {
					if (item.nameZh === "网上预约") {
						return true;
					}
				});
				this.nowMenuId = menu.id;
			},
			getMenuLink(item) {
				if (item.isOut == 1) {
					return item.url;
				}
				return '/detail?id=' + item.id + '&pid=' + item.parentId;
			},
			submitForm() {
				this.loading = true;
				const _this = this;
				api.submitBook(this.form).then(res => {
						_this.loading = false;
						var type;
						if (res.success) {
							type = "success";
							_this.form = defaultForm;
							_this.getCode();
						} else {
							type = "error";
							_this.code = res.data;
							_this.form.codeKey = res.data.code;
						}
						_this.$alert(res.msg, "提示", {
							confirmButtonText: '确定',
							type: type
						});
					})
					.catch(res => {
						_this.loading = false;
						_this.$alert(res.message, "提示", {
							confirmButtonText: '确定',
							type: "warning"
						})
					})
			}
		},
		created() {
			this.getCode();
		},
		mounted() {
			this.$refs.main.scrollIntoView();
		}
	}
</script>

<style>
	.title {
		font-size: 24px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		margin-bottom: 35px;
	}

	.btn-submit {
		margin-top: 50px;
		width: 90px;
		height: 46px;
		background: #A10000;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #FFFFFF;
		text-align: center;
		line-height: 46px;
	}

	.code {
		margin-left: 20px;
		width: 100px;
		height: 50px;
		vertical-align: middle;
		cursor: pointer;
	}

	.el-form-item__label {
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
	}

	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.detail-container {
		margin: 23px 0 30px 30px;
		padding-right: 50pxs;
		width: 100%;
	}

	.menu-container {
		margin-right: 30px;
		background: #F7F7F7;
		height: fit-content;
	}

	.menu-item-container {
		width: 166px;
		height: 55px;
		color: #666666;
	}

	.menu-item-icontainer-active {
		background: #A10000;
		color: #FFFFFF !important;
	}

	.el-input__inner::-webkit-input-placeholder {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.el-input__inner::-moz-placeholder {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.el-input__inner:-ms-input-placeholder {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	.el-input__inner::-webkit-input-placeholder {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}

	input::placeholder {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #999999;
	}
</style>



// WEBPACK FOOTER //
// src/views/booking/index.vue